import { ScoreValues } from './score-values';

export class TeeType {
    id?: number;
    name: string;
    scoreValues: ScoreValues[];

    get scoreHoles(): ScoreValues {
        if (this.scoreValues !== undefined) {
            return this.scoreValues.find(v => v.name === 'Holes');
        }
    }

    get scoreData(): ScoreValues[] {
        if (this.scoreValues !== undefined) {
            return this.scoreValues.filter(v => v.name !== 'Holes');
        }
    }
}
